<template>
  <nuttrema-layout-form-standard
     class="is-center-padding-top-1em"
    :edit="true"
    :saveError="InstanceSubscriptionDetails.saveError">
    <template slot="center">
       <el-form
        :model="formData"
        ref="source-details"
        label-width="20em">

        <section>
          <div class="section-items">
            <el-collapse v-model="activeName" accordion>
              <el-collapse-item :title="$t('label.main_information')" name="1">
                <dl class="nuttrema-description-list--main-details">
                  <dt>{{ $t('label.name') }}</dt>
                  <dd>{{ _get(InstanceSubscriptionDetails, 'data.name') }}</dd>
                  <dd class="desc">{{ _get(InstanceSubscriptionDetails, 'data.outline') }}</dd>

                  <dt>{{ $t('label.duration') }}</dt>
                  <dd>{{ _get(InstanceSubscriptionDetails, 'data.start_date') | moment('LL') }} - {{ _get(InstanceSubscriptionDetails, 'data.end_date') | moment('LL') }}</dd>

                  <dt>{{ $t('label.status') }}</dt>
                  <dd>{{ $t(`label.${_get(InstanceSubscriptionDetails, 'data.status')}`) }}</dd>

                </dl>
              </el-collapse-item>

              <el-collapse-item :title="$t('label.subscribed_features')" name="2">
                <dl class="nuttrema-description-list--main-details">
                  <template v-for="subscribedFeature in _get(InstanceSubscriptionDetails, 'data.SubscribedFeatures', [])">
                    <dt>{{ _get(subscribedFeature, 'name') }}</dt>
                    <dd v-for="option in _get(subscribedFeature, 'SubscribedFeatureOptions', [])">
                      {{ _get(option, 'description') }}
                    </dd>
                    <dd v-if="subscribedFeature.control_type === 'counter' && _get(InstanceSubscriptionDetails, 'data.status') === 'current'">
                      <el-tooltip
                         class="item"
                         effect="dark"
                         placement="right"
                         style="margin-bottom: 1em"
                        :open-delay="500"
                        :content="$t('label.used_out_of', { upper_limit: subscribedFeature.upper_limit, used_count: subscribedFeature.used_count })">
                        <el-progress :percentage="calculatePercentage(subscribedFeature.upper_limit, subscribedFeature.used_count)"></el-progress>
                      </el-tooltip>
                    </dd>
                  </template>
                </dl>
              </el-collapse-item>

              <el-collapse-item :title="$t('label.invoices')" name="3" v-if="!_isEmpty(_get(InstanceSubscriptionInvoicesList, 'data', []))">
                <table class="subscription-invoices-list">
                  <thead>
                    <tr>
                      <th class="align-right">{{ $t('label.no') }}</th>
                      <th>{{ $t('label.invoice_type') }}</th>
                      <th>{{ $t('label.issue_date') }}</th>
                      <th>{{ $t('label.price') }}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="invoice in _get(InstanceSubscriptionInvoicesList, 'data', [])">
                      <td class="align-right">{{ invoice.invoice_no }}</td>
                      <td>{{ $t(`label.${invoice.invoice_type}`) }}</td>
                      <td>{{ invoice.issue_date | moment('ll') }}</td>
                      <td>{{ invoice.total }} {{ invoice.Currency.symbol }}</td>
                      <td>
                        <router-link
                           tag="a"
                          :title="$t('label.invoice_details')"
                          :to="{ name: _get(meta, 'navigation.details'), params: { invoice_id: invoice.id } }">
                          <i class="far fa-chevron-right"></i>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </el-collapse-item>

            </el-collapse>
          </div>

        </section>
      </el-form>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { get } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';

export default {
  name: 'form-instance-subscription-details',
  props: {
    meta: {
      required: true,
      default: null,
    },
    InstanceSubscriptionDetails: {
      required: true,
      default: null,
    },
    InstanceSubscriptionInvoicesList: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {},
      activeName: ['1'],
    };
  },
  methods: {
    submitForm() {
      const action = get(this.InstanceSubscriptionDetails, 'data.active') ? 'deactivate' : 'activate';
      this.$emit('submit', action);
    },
    cancel() {
      this.$emit('cancel');
    },
    calculatePercentage(upperLimit, usedCount) {
      return (usedCount * 100) / upperLimit;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~styles/component/nuttrema_list_global_style';

  .el-collapse {
    border-top: none;
    border-bottom: none;

    /deep/ .el-collapse-item {
      .el-collapse-item__header {
        background-color: transparent;
      }
      .el-collapse-item__wrap {
        background-color: transparent;
      }
      &:last-child {
        .el-collapse-item__header {
          border-bottom: none;
        }
      }
    }
  }

  .subscription-invoices-list {
    td, th {
      &.align-right {
        text-align: right;
        padding-right: 0.5em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/instance-subscriptions/details/form-instance-subscription-details.vue